export default "__VITE_ASSET__gkkiDhsz__"